import { lazy } from "react";

// project imports
import Loadable from "ui-component/Loadable";
import AuthGuard from "utils/route-guard/AuthGuard";
import MainLayout from "layout/MainLayout";
import NavMotion from "layout/NavMotion";
import GuestGuard from "utils/route-guard/GuestGuard";
import MinimalLayout from "layout/MinimalLayout";

// Master routing
const SelectInstitute = Loadable(lazy(() => import("views/pages/authentication/AlumniOauthRegistration/SelectInstitute")));
const CreateNetwork = Loadable(lazy(() => import("views/pages/authentication/AlumniOauthRegistration/CreateNetwork")));
// ==============================|| AUTH ROUTING ||============================== //

const AlumniOauthRegisterRoute = {
  path: "/",
  element: (
    <NavMotion>
      <GuestGuard>
        <MinimalLayout />
      </GuestGuard>
    </NavMotion>
  ),
  children: [
    {
      path: "/select/institute",
      element: <SelectInstitute />,
    },
    {
      path: "/create/network",
      element: <CreateNetwork />,
    },
  ],
};

export default AlumniOauthRegisterRoute;
